import GradientFactory from './GradientFactory';

export default GradientFactory;
